export default (controller) => {
  Object.assign(controller, {
    openDialogHandler() {
      this.dialogCheckBoxTargets.forEach((target) => {
        const listCheckBox = this.listCheckBoxTargets
          .find((el) => el.dataset.value === target.dataset.value);
        if (!listCheckBox) {
          return;
        }

        target.checked = listCheckBox.checked;
        target.dispatchEvent(new Event('input'));
      });
    },

    changeDialogHandler() {
      this.dialogCheckBoxTargets.forEach((target) => {
        const listCheckBox = this.listCheckBoxTargets
          .find((el) => el.dataset.value === target.dataset.value);
        if (!listCheckBox) {
          return;
        }

        listCheckBox.checked = target.checked;
      });

      this.displayCheckedListItem();
      this.reorder();
    },

    displayCheckedListItem() {
      this.listItemTargets.forEach((listItem) => {
        if (listItem.querySelector('input').checked) {
          listItem.classList.remove('hidden');
        } else {
          listItem.classList.add('hidden');
        }
      });
    },

    reorder() {
      let counter = 0;
      this.orderTargets.forEach((target) => {
        if (target.offsetParent === null) {
          return;
        }

        counter += 1;
        target.innerHTML = `${counter}.`;
      });

      if (counter === 0) {
        this.borderTarget.classList.add('hidden');
      } else {
        this.borderTarget.classList.remove('hidden');
      }
    },
  });
};
